var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var updateChat = function (id, prevState, field, value) {
    var _a;
    if (!prevState.chats) {
        return prevState;
    }
    var updatedChatIndex = prevState.chats.findIndex(function (chat) { return chat.id === id; });
    if (updatedChatIndex === -1) {
        return prevState;
    }
    var chatsBefore = prevState.chats.slice(0, updatedChatIndex);
    var chatsAfter = prevState.chats.slice(updatedChatIndex + 1);
    var updatedChat = prevState.chats[updatedChatIndex];
    var chats = __spreadArray(__spreadArray(__spreadArray([], chatsBefore, true), [__assign(__assign({}, updatedChat), (_a = {}, _a[field] = value, _a))], false), chatsAfter, true);
    return { chats: chats, selectedChatId: prevState.selectedChatId };
};
var chatsReducer = function (prevState, action) {
    var _a;
    switch (action.type) {
        case 'populate_chats': {
            return { chats: action.state.chats, selectedChatId: action.state.selectedChatId };
        }
        case 'select_chat': {
            return { chats: prevState.chats, selectedChatId: action.state.selectedChatId };
        }
        case 'add_chat': {
            var chats = __spreadArray([action.state.newChat], (prevState.chats || []), true);
            var selectedChatId = action.state.newChat.id;
            return { chats: chats, selectedChatId: selectedChatId };
        }
        case 'edit_chat_name': {
            var _b = action.state, id = _b.id, name_1 = _b.name;
            return updateChat(id, prevState, 'name', name_1);
        }
        case 'edit_chat_rag_source_id': {
            var _c = action.state, id = _c.id, ragSourceId = _c.ragSourceId;
            return updateChat(id, prevState, 'ragSourceId', ragSourceId);
        }
        case 'delete_chat': {
            if (!prevState.chats) {
                return prevState;
            }
            var id_1 = action.state.id;
            var chats = prevState.chats.filter(function (chat) { return chat.id !== id_1; });
            var selectedChatId = prevState.selectedChatId === id_1 ? (_a = chats[0]) === null || _a === void 0 ? void 0 : _a.id : prevState.selectedChatId;
            return { chats: chats, selectedChatId: selectedChatId };
        }
    }
};
export default chatsReducer;
